import { z } from 'zod'
import { overviewTileTypes } from 'app/frontend/types/custom/OverviewTileType'
import { accessLevels } from 'app/frontend/types/custom/AccessLevel'
import { overviewTilePositions } from 'app/frontend/types/custom/OverviewTilePosition'

export const MAIN_FIELD = 'main_overview_tiles_attributes'
export const SIDEBAR_FIELD = 'sidebar_overview_tiles_attributes'

const tileSchema = z.object({
  id: z.number().optional(),
  type: z.enum(overviewTileTypes),
  accessLevel: z.enum(accessLevels),
  order: z.number(),
  config: z.record(z.any()).default({}),
  position: z.enum(overviewTilePositions),
  pending: z.boolean().optional(),
  _destroy: z.boolean().optional(),
})

export const formSchema = z.object({
  [MAIN_FIELD]: z.array(tileSchema),
  [SIDEBAR_FIELD]: z.array(tileSchema),
})

export type FormValues = z.infer<typeof formSchema>
